import React from "react";
import Dropdown from "components/dropdown";
import { FiAlignJustify } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { FiSearch } from "react-icons/fi";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import {
  IoMdNotificationsOutline,
  IoMdInformationCircleOutline,
} from "react-icons/io";
import avatar from "assets/img/avatars/avatar4.png";
import api from "services/api";

const R2 = process.env.REACT_APP_R2_PUBLIC_URL || "https://pub-26704679c67f47a28bce53f5dac3f586.r2.dev";

const Navbar = (props) => {
  const { onOpenSidenav, brandText } = props;
  const [darkmode, setDarkmode] = React.useState(false);
  const [session, setSession] = React.useState(null);
  const [query, setQuery] = React.useState("");
  // Catalogue warnings computed by the API: missing posters, movies with no
  // video, series with no episodes. The template shipped a hardcoded "No new
  // notifications" and never called anything.
  const [notifications, setNotifications] = React.useState([]);
  const [notificationsFailed, setNotificationsFailed] = React.useState(false);

  React.useEffect(() => {
    let cancelled = false;
    api
      .getNotifications()
      .then((data) => {
        if (!cancelled) setNotifications(Array.isArray(data?.items) ? data.items : []);
      })
      .catch(() => {
        if (!cancelled) setNotificationsFailed(true);
      });
    return () => {
      cancelled = true;
    };
  }, []);
  const navigate = useNavigate();

  const runSearch = (e) => {
    if (e.key !== "Enter") return;
    const term = query.trim();
    if (!term) return;
    navigate(`/admin/search?q=${encodeURIComponent(term)}`);
  };

  React.useEffect(() => {
    api.getSession().then((res) => {
      if (res?.loggedIn) setSession(res.user);
    }).catch(console.error);
  }, []);

  const currentAvatar = session?.avatarUrl ? `${R2}/${session.avatarUrl}` : avatar;

  return (
    <nav className="sticky top-4 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      <div className="ml-[6px]">
        <div className="h-6 w-[224px] pt-1">
          <a
            className="text-sm font-normal text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            href=" "
          >
            Pages
            <span className="mx-1 text-sm text-navy-700 hover:text-navy-700 dark:text-white">
              {" "}
              /{" "}
            </span>
          </a>
          <Link
            className="text-sm font-normal capitalize text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            to="#"
          >
            {brandText}
          </Link>
        </div>
        <p className="shrink text-[33px] capitalize text-navy-700 dark:text-white">
          <Link
            to="#"
            className="font-bold capitalize hover:text-navy-700 dark:hover:text-white"
          >
            {brandText}
          </Link>
        </p>
      </div>

      <div className="relative mt-[3px] flex h-[61px] w-[355px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[365px] md:flex-grow-0 md:gap-1 xl:w-[365px] xl:gap-2">
        <div className="flex h-full items-center rounded-full bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white xl:w-[225px]">
          <p className="pl-3 pr-2 text-xl">
            <FiSearch className="h-4 w-4 text-gray-400 dark:text-white" />
          </p>
          <input
            type="text"
            placeholder="Search movies…"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={runSearch}
            className="block h-full w-full rounded-full bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white sm:w-fit"
          />
        </div>
        <span
          className="flex cursor-pointer text-xl text-gray-600 dark:text-white xl:hidden"
          onClick={onOpenSidenav}
        >
          <FiAlignJustify className="h-5 w-5" />
        </span>
        {/* start Notification */}
        <Dropdown
          button={
            <p className="relative cursor-pointer">
              <IoMdNotificationsOutline className="h-4 w-4 text-gray-600 dark:text-white" />
              {notifications.length > 0 && (
                <span className="absolute -right-1.5 -top-1.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-red-500 px-1 text-[10px] font-bold leading-none text-white">
                  {notifications.length > 9 ? "9+" : notifications.length}
                </span>
              )}
            </p>
          }
          animation="origin-[65%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
          children={
            <div className="flex w-[360px] flex-col gap-3 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none sm:w-[460px]">
              <div className="flex items-center justify-between">
                <p className="text-base font-bold text-navy-700 dark:text-white">
                  Needs attention
                </p>
                {notifications.length > 0 && (
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    {notifications.length} item{notifications.length === 1 ? "" : "s"}
                  </p>
                )}
              </div>

              {notificationsFailed ? (
                <p className="py-6 text-center text-sm text-gray-500 dark:text-white">
                  Could not load notifications. Check your connection and reload.
                </p>
              ) : notifications.length === 0 ? (
                <p className="py-6 text-center text-sm text-gray-500 dark:text-white">
                  Nothing needs attention — every title has its poster and video.
                </p>
              ) : (
                <div className="flex max-h-[320px] flex-col gap-1 overflow-y-auto">
                  {notifications.map((item) => (
                    <Link
                      key={item.id}
                      to={item.href}
                      className="flex items-start gap-3 rounded-xl p-2 transition-colors hover:bg-gray-100 dark:hover:bg-navy-800"
                    >
                      <span
                        className={`mt-1.5 h-2 w-2 flex-none rounded-full ${
                          item.severity === "warning" ? "bg-amber-500" : "bg-blue-500"
                        }`}
                      />
                      <span className="min-w-0">
                        <span className="block text-sm font-bold text-navy-700 dark:text-white">
                          {item.title}
                        </span>
                        <span className="block text-xs text-gray-600 dark:text-gray-300">
                          {item.detail}
                        </span>
                      </span>
                    </Link>
                  ))}
                </div>
              )}
            </div>
          }
          classNames={"py-2 top-4 -left-[230px] md:-left-[440px] w-max"}
        />
        <div
          className="cursor-pointer text-gray-600"
          onClick={() => {
            if (darkmode) {
              document.body.classList.remove("dark");
              setDarkmode(false);
            } else {
              document.body.classList.add("dark");
              setDarkmode(true);
            }
          }}
        >
          {darkmode ? (
            <RiSunFill className="h-4 w-4 text-gray-600 dark:text-white" />
          ) : (
            <RiMoonFill className="h-4 w-4 text-gray-600 dark:text-white" />
          )}
        </div>
        {/* Profile & Dropdown */}
        <Dropdown
          button={
            <img
              className="h-10 w-10 rounded-full object-cover bg-white"
              src={currentAvatar}
              alt="Profile"
            />
          }
          children={
            <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="p-4">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    👋 Hey, {session?.email?.split('@')[0] || 'Admin'}
                  </p>{" "}
                </div>
              </div>
              <div className="h-px w-full bg-gray-200 dark:bg-white/20 " />

              <div className="flex flex-col p-4">
                <Link
                  to="/admin/profile"
                  className="text-sm text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Profile Settings
                </Link>
                <button
                  onClick={() => api.logout()}
                  className="mt-3 flex items-start text-sm font-medium text-red-500 hover:text-red-500 transition duration-150 ease-out hover:ease-in"
                >
                  Log Out
                </button>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
      </div>
    </nav>
  );
};

export default Navbar;
